<template>
  <div>
    <el-form :model="form">
      <div class="radio_box">
        <span style="margin-right:15px;">异常类型:</span>
        <!-- <el-radio-group v-model="form.appealType">
          <el-radio label="运费异常">运费异常</el-radio>
          <el-radio label="轨迹异常">轨迹异常</el-radio>
          <el-radio label="其他异常">其他异常</el-radio>
        </el-radio-group> -->
        <el-checkbox-group v-model="form.appealType">
          <el-checkbox label="运费异常"></el-checkbox>
          <el-checkbox label="轨迹异常"></el-checkbox>
          <el-checkbox label="其他异常"></el-checkbox>
        </el-checkbox-group>
      </div>

      <el-input
        v-model="form.authorizeCause"
        type="textarea"
        maxlength="255"
        show-word-limit
        :rows="5"
        placeholder="请输入内容"
      />
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="rejxiao()">取 消</el-button>
      <el-button type="primary" @click="rejque(message)">确 定</el-button>
    </div>
  </div>
</template>
<script>
import { reviewAppeal } from "@/api/transport";
export default {
  props: ["message"],
  data() {
    return {
      form: {
        authorizeCause: "",
        code: "",
        appealType: ["运费异常"],
        rejectionType: 1
      }
    };
  },
  created() {},
  methods: {
    rejque(message) {
      if (!this.form.appealType.length) {
        return this.$message({
          message: "请选择异常类型",
          type: "warning"
        });
      }
      this.form.codes = message;
      let data = {
        ...this.form,
        appealType: this.form.appealType.join(","),
        status: 2
      };
      reviewAppeal(data).then(response => {
        this.form.authorizeCause = "";
        this.$emit("event1", true);
      });
    },
    rejxiao() {
      this.form.authorizeCause = "";
      this.$emit("event1", false);
    }
  }
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin-top: 50px;
}
.radio_box {
  margin-bottom: 20px;
  margin-top: 20px;
}
</style>
